document.addEventListener("DOMContentLoaded", function () {
    const videoOverlay = document.getElementById("video-overlay");
    const video = document.getElementById("intro-video");
    const videoSource = document.getElementById("video-source");

    const mobileVideo = "https://cdn.shopify.com/videos/c/o/v/3204e1a1777e4e1fb666c223d04e7d24.mp4";
    const desktopVideo = "https://cdn.shopify.com/videos/c/o/v/a0df6fa174f24b0e9f3c30e7fed92f57.mp4";

    function isMobile() {
        return window.innerWidth < 768;
    }

    // Check if video has already played in this session
    if (sessionStorage.getItem("videoPlayed")) {
        videoOverlay.style.display = "none"; // Hide overlay if video already played
        return;
    }

    videoSource.src = isMobile() ? mobileVideo : desktopVideo;
    video.load();

    video.addEventListener("click", function () {
        video.play();
    });

    video.addEventListener("loadedmetadata", function () {
        const fadeOutTime = video.duration - 1;
        video.addEventListener("timeupdate", function () {
            if (video.currentTime >= fadeOutTime) {
                videoOverlay.style.transition = "opacity 1s ease";
                videoOverlay.style.opacity = "0";

                setTimeout(() => {
                    videoOverlay.style.display = "none"; // Just hide, no refresh
                    sessionStorage.setItem("videoPlayed", "true"); // Store session info
                }, 1500);
            }
        });
    });

    // 🛠️ Safety Mechanism: If fade-out doesn’t work, force-hide after video ends
    video.addEventListener("ended", function () {
        videoOverlay.style.display = "none"; 
        sessionStorage.setItem("videoPlayed", "true");
    });
});